<div *ngIf="isDescription">
	<p>Beschreibung</p>
</div>

<div *ngIf="isOutcomeChallenger">
	<p>Bedingung für deinen Sieg</p>
</div>

<div *ngIf="isOutcomeCompetitor">
	<p>Bedingung für den Sieg deines Gegners</p>
</div>

<div *ngIf="isDescriptionGuess">
	<p>
		Stelle eine Frage, deren Antwort eine Zahl ist. Z.B. "Wie viele Einwohner hat Berlin?" oder "Wie viele Tore werden
		im nächsten Spiel fallen?"
	</p>
</div>

<div *ngIf="isChallengerGuess">
	<p>Gib deine Schätzung als Zahl ein. Wer näher an der richtigen Antwort liegt, gewinnt das Duell.</p>
</div>
